import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByRefererComponent from '../../../../utils/ReportByRefererComponent/ReportByRefererComponent';
import { statisticsByReferer } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByRefererSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByReferer && statisticsByReferer.groupParamsSegment) || []}
        reportComponent={ReportByRefererComponent}
        translationKey="statisticsByReferer"
    />
);

export default StatisticsByRefererSegments;
